import { events } from "@constants/tracking";
/* -----------------Icons--------------- */
import { useAppTheme } from "@hooks/useAppTheme";
import { trackCustomEvent } from "analytics";
import { ConfirmDialog } from "components/ConfirmDialog";
import { useEffect } from "react";
import { Button } from "react-native-paper";
import {
	type DialogType,
	dialogSessionConfigs,
} from "../constants/dialog-configs";

type Props = {
	open: boolean;
	handleClose?: () => void;
	type?: DialogType;
	handleClickButton?: (type: string) => void;
	customConfig?: {
		title: string;
		content: string;
		buttons?: {
			label: string;
			type: "cancel" | "confirm";
		}[];
		icon: string;
	};
	maxWidth?: unknown;
	showCloseButton?: boolean;
	subtitleComponent?: React.ReactNode;
};
export default function DialogSession({
	open,
	handleClose,
	type = "pause",
	handleClickButton,
	customConfig,
	maxWidth,
	showCloseButton = true,
	subtitleComponent,
}: Props) {
	const theme = useAppTheme();
	const { title, content, buttons, icon } =
		customConfig || dialogSessionConfigs[type];
	const colorMap: Record<string, string> = {
		cancel: theme.colors.onSurfaceVariant,
		confirm: theme.colors.primary,
	};

	const handleDialogClose = () => {
		handleClose?.();
		trackCustomEvent({
			eventName: events.dialogClosed,
			type,
		});
	};
	useEffect(() => {
		if (open) {
			trackCustomEvent({
				eventName: events.dialogOpened,
				type,
			});
		}
	}, [open, type]);
	const renderActions = () => (
		<>
			{handleClickButton &&
				buttons &&
				buttons.map(({ label, type }) => (
					<Button
						key={label}
						onPress={() => {
							handleClickButton(type);
						}}
						textColor={colorMap[type]}
					>
						{label}
					</Button>
				))}
		</>
	);
	return (
		<ConfirmDialog
			visible={open}
			dismissCallback={handleDialogClose}
			body={content}
			showCloseButton={showCloseButton}
			title={title}
			subtitleComponent={subtitleComponent}
			maxWidth={maxWidth}
			icon={icon}
			actions={renderActions()}
		/>
	);
}
